import { Check, Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface SaveStatusIndicatorProps {
  status: 'idle' | 'saving' | 'saved';
}

export const SaveStatusIndicator = ({ status }: SaveStatusIndicatorProps) => {
  if (status === 'idle') return null;

  return (
    <div className={cn(
      "flex items-center gap-1.5 text-xs transition-all duration-300",
      status === 'saving' && "text-muted-foreground",
      status === 'saved' && "text-green-600 dark:text-green-500"
    )}>
      {status === 'saving' && (
        <>
          <Loader2 className="h-3 w-3 animate-spin" />
          <span>Speichern...</span>
        </>
      )}
      {status === 'saved' && (
        <>
          <Check className="h-3 w-3" />
          <span>Fortschritt gespeichert</span>
        </>
      )}
    </div>
  );
};
